import React from 'react';
import MenuItem from 'flow/components/ui-components/MenuItem';
import NestedMenuItem from 'flow/components/ui-components/NestedMenuItem';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { getIsSinglePaneMode } from 'flow/selectors/selectors';
import { ChatSession } from 'flow/types/Chats';
import { SummaryOption } from 'flow/types/SummarizeMessage';
import { TypedMap } from 'flow/types/TypedMap';
import { getSummaryOptions } from 'flow/utils/chat-utils';

interface Props {
    session: TypedMap<ChatSession>;
}

const GenerateSummaryMenuItem = ({ session }: Props) => {
    const { i18next } = useAppContext();
    const { openModal } = useModal();

    const isSinglePaneMode = useAppSelector(getIsSinglePaneMode);

    const unreadMessages = session.get('numberOfUnreadMessages', 0);

    return (
        <NestedMenuItem
            title={i18next.t('ai.summary.generate')}
            placementDesired={isSinglePaneMode ? 'left-start' : 'right'}
            className={isSinglePaneMode ? 'min-w-[150px]' : null}
        >
            {unreadMessages > 0 && (
                <MenuItem
                    onClick={(e) => {
                        e.stopPropagation();
                        openModal('chatSummary', {
                            chatSessionKey: session.get('key'),
                            summaryOption: SummaryOption.Unread,
                        });
                    }}
                >
                    {i18next.t('chat.generateSummary.options.unread', {
                        total: unreadMessages,
                    })}
                </MenuItem>
            )}

            {getSummaryOptions(i18next).map((option) => (
                <MenuItem
                    key={option.key}
                    onClick={(e) => {
                        e.stopPropagation();
                        openModal('chatSummary', {
                            chatSessionKey: session.get('key'),
                            summaryOption: option.key,
                        });
                    }}
                >
                    {option.label}
                </MenuItem>
            ))}
        </NestedMenuItem>
    );
};

export default GenerateSummaryMenuItem;
